module.exports = __webpack_public_path__ + "img/Youtube.d89e2389.svg";